import React from 'react'
import Seo from './Seo';

const AboutUs = () => {
    return (
        <div className="page pt-32">
            <Seo
                title="About Us | CompressImages.org"
                description="Discover the mission behind CompressImages.org and how it helps users compress images privately in the browser."
                path="/about"
            />

            <article className="article-wrap">
                <div className="article-tag">About</div>
                <h1 className="article-title">A private image utility for everyday compression work.</h1>
                <div className="article-body">
                    <p>
                        <strong>CompressImages.org</strong> is a free, privacy-focused web app for optimizing and compressing images directly in the browser.
                    </p>
                    <p>
                        The mission is simple: make image compression fast, secure, and accessible without asking users to upload private files to a remote server. All image processing happens client-side with browser APIs and canvas rendering.
                    </p>
                    <h2>Built for common workflows</h2>
                    <ul>
                        <li>Bloggers and website owners improving page load times</li>
                        <li>E-commerce sellers optimizing product photos</li>
                        <li>Students and professionals sending smaller images by email</li>
                        <li>Creators preparing images for social media and portfolios</li>
                    </ul>
                    <h2>Open, lightweight, private</h2>
                    <p>
                        CompressImages.org runs without accounts, logins, or API keys. You choose an image, your browser creates an optimized copy, and you download the result.
                    </p>
                    <p>
                        Questions or collaboration ideas can be sent to <a href="mailto:contact@compressimages.org">contact@compressimages.org</a>.
                    </p>
                </div>
            </article>
        </div>
    )
}

export default AboutUs
